import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

export type JobOffersModalProps = {
  modalTitle: string,
  onClose: () => void,
  children: React.ReactNode,
  dataCy?: string,
}

const StyledOverLay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overscroll-behavior: contain;
  overflow-y: scroll;
  touch-action: auto;
`

const StyledModalContainer = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  overflow-y: hidden;
  max-height: 80vh;
  width: 295px;
  z-index: 2;
  margin: auto;
  box-shadow: 0px 0px 20px 0px #00000040;

  @media ${props => props.theme.media.sm} {
    width: 700px;
    max-height: 650px;
  }
`

const StyledModalTitleContainer = styled.div`
  display: flex;
  color: ${props => props.theme.members.colors.white};
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.7rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 1rem;
  background: ${props => props.theme.members.colors.silver._70};
  justify-content: space-between;
  z-index: 3;

  @media screen and ${props => props.theme.media.sm} {
    font-size: 1.25rem;
    line-height: 2.125rem;
  }
`

const StyledContentContainer = styled.div`
  margin: 0;
  padding: 0;
`

const StyledCloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  vertical-align: middle;
`

export const StyledJobOffersModal: React.FC<JobOffersModalProps> = (props: JobOffersModalProps) => {
  return (
    <StyledOverLay>
      <StyledModalContainer data-cy={props.dataCy && `job-offer-${props.dataCy}-modal`}>
        <StyledModalTitleContainer>
          {props.modalTitle}
          <StyledCloseButton type='button' onClick={props.onClose}><FontAwesomeIcon icon={faXmark} color='white' /></StyledCloseButton>
        </StyledModalTitleContainer>
        <StyledContentContainer>
          {props.children}
        </StyledContentContainer>
      </StyledModalContainer>
    </StyledOverLay>
  )
}
